$(document).ready(function(){
	
	function pestaniasWidth() {
		tamanioPestanias=0;
		$(".menuTabBanner").find(".swiper-slide").each(function(){
			tamanioPestanias = tamanioPestanias + $(this).width();
		})
		return tamanioPestanias;
	}
	var tamanioPestanias = pestaniasWidth();
	if ($("section.tabs-banner-movil").length > 0){
		var tabSwiperMobile = new Swiper('.tabs-banner-movil .swiper-container', {
			mode:'horizontal',
			slidesPerView: 'auto',
			visibilityFullFit: true,
			cssWidthAndHeight: true,
			keyboardControl: true,
			calculateHeight: true,
			nextButton: ".swiper-button-next",
			prevButton: ".swiper-button-prev"
		});


		$(".menuTabBanner").find(".tabBanner0").addClass("activeTab");
		$(".menuTabBanner").addClass("dataActive");
		$(".tab-banner-content .tab-banner-content").eq(0).addClass("dataActive");
		// arrowSelected();

		$(".tab-banner-label").on("click", function(e){
			console.log("width: " + $(window).width());
			if ($(window).width()<tamanioPestanias){
				$('.swiper-wrapper').css({"transform": "translate3d(-" + $("#"+$(this).attr("id")).position().left/2 + "px, 0px, 0px)"});
			}
			var numElementBefore = $(".tab-banner-content .content-img .imgTab.dataActive").index();
			var numElement = $(this).index();
			if ($(this).index() ===$(".swiper-slide.tab-banner-label").length-1){
				disabledArrows($(".tab-banner-content .nextTabBanner"));
				enabledArrows($(".tab-banner-content .prevTabBanner"));
			}
			else if ($(this).index()===0) {
				disabledArrows($(".tab-banner-content .prevTabBanner"));
				enabledArrows($(".tab-banner-content .nextTabBanner"));
			}
			else {
				enabledArrows($(".tab-banner-content .prevTabBanner"));
				enabledArrows($(".tab-banner-content .nextTabBanner"));
			}
			$(".menuTabBanner .tab-banner-label").css("pointer-events", "none")
			$(".tab-banner-label").removeClass("activeTab");
			$(this).addClass("activeTab");
			$(".tab-banner-content .tab-banner-content.dataActive iframe").remove();
			var actualTab = $(".tab-banner-content .tab-banner-content.dataActive .content-video-banner-tab");
			var strVideo = actualTab.data('video-id');
			var id = 'player-' + Date.now() + parseInt(Math.random() * 100000000);
			if (strVideo.indexOf("?") == -1 ){
				actualTab.append('<iframe id="'+ id + '" src="https://www.youtube.com/embed/' + strVideo + '?rel=0&enablejsapi=1" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>');
			}
			else {
				actualTab.append('<iframe id="'+ id + '" src="https://www.youtube.com/embed/' + strVideo + '&rel=0&enablejsapi=1" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>');
			}
			$(".tab-banner-content .tab-banner-content.dataActive").removeClass("dataActive");
			$(".tab-banner-content .tab-banner-content").eq(numElement).addClass("dataActive");
			$(".tab-banner-content .content-img .imgTab.dataActive").addClass("activePre");
			$(".tab-banner-content .content-img .imgTab").eq(numElement).addClass("dataActive");
				setTimeout(function(){ 
					$(".tab-banner-content .content-img .imgTab").eq(numElementBefore).removeClass("activePre dataActive");
					$(".menuTabBanner .tab-banner-label").css("pointer-events", "initial");}
				, 500);
			// arrowSelected();
		})


		// CREACIÓN DE IFRAME DE VIDEO EN TABS
		$(".content-video-banner-tab").each(function() {
			var strVideo = $(this).data('video-id');
			var id = 'player-' + Date.now() + parseInt(Math.random() * 100000000);
			if (strVideo.indexOf("?") == -1 ){
				$(this).append('<iframe id="'+ id + '" src="https://www.youtube.com/embed/' + strVideo + '?rel=0&enablejsapi=1" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>');
			}
			else {
				$(this).append('<iframe id="'+ id + '" src="https://www.youtube.com/embed/' + strVideo + '&rel=0&enablejsapi=1" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>');
			}
		});

		// FIN CREACIÓN DE IFRAME DE VIDEO EN TABS

		//ANCHO DE LA PÁGINA PARA CONTROL DEL TRIÁNGULO AZUL FIN DE BLOQUE
		
		function widthTriangle(){
			var widthWindow = $(window).width()+"px";
			$(".tab-banner-content-END").css("border-right-width", widthWindow)
		}

		widthTriangle();

		$( window ).resize(function() {
			widthTriangle();
		});

		//FIN ANCHO DE LA PÁGINA PARA CONTROL DEL TRIÁNGULO AZUL FIN DE BLOQUE

		// CONTROL DE FLECHAS SUPERIORES DEL SWIPER
		function comprobacionNextPrev(){

			if ($(".menuTabBanner .swiper-button-prev").hasClass("swiper-button-disabled") && $(".menuTabBanner .swiper-button-next").hasClass("swiper-button-disabled")){
				$(".menuTabBanner .prevTabBanner").hide();
				$(".menuTabBanner .nextTabBanner").hide();
			}
			else {
				if ($(".menuTabBanner .swiper-button-prev").hasClass("swiper-button-disabled")){
					$(".menuTabBanner .prevTabBanner").css("opacity", "0.6");
					$(".menuTabBanner .prevTabBanner").css("pointer-events", "none");
				} else {
					$(".menuTabBanner .prevTabBanner").css("opacity", "1");
					$(".menuTabBanner .prevTabBanner").css("pointer-events", "initial");
				}

				if ($(".menuTabBanner .swiper-button-next").hasClass("swiper-button-disabled")){
					$(".menuTabBanner .nextTabBanner").css("opacity", "0.6");
					$(".menuTabBanner .nextTabBanner").css("pointer-events", "none");
				} else {
					$(".menuTabBanner .nextTabBanner").css("opacity", "1");
					$(".menuTabBanner .nextTabBanner").css("pointer-events", "initial");
				}
			}
		};


		comprobacionNextPrev();



		$(".menuTabBanner .prevTabBanner").on("click", function(){
			sliderPrevView();
		})

		$(".menuTabBanner .nextTabBanner").on("click", function(){
			sliderNextView();
		})

		function sliderPrevView(){
			$(".menuTabBanner .swiper-button-prev").trigger("click");
			comprobacionNextPrev();
		}

		function sliderNextView(){
			$(".menuTabBanner .swiper-button-next").trigger("click");
			comprobacionNextPrev();
		}

		// FIN CONTROL DE FLECHAS SUPERIORES DEL SWIPER


		// CONTROL DE FLECHAS INFERIORES, RECORREN DE 1 EN 1 LAS PESTAÑAS DEL SWIPER

		function disabledArrows(arrowToDisabled){
			arrowToDisabled.css("opacity", "0.6");
			arrowToDisabled.css("pointer-events", "none");
		};

		function enabledArrows(arrowToEnabled){
			arrowToEnabled.css("opacity", "1");
			arrowToEnabled.css("pointer-events", "initial");

		};
		// SI HAY MÁS DE UNA PESTAÑA SE CONTROLA

		if ($(".menuTabBanner .swiper-slide").length > 1 ){


			disabledArrows($(".tab-banner-content .prevTabBanner"));

			$(".tab-banner-content .prevTabBanner").on("click", function(){
				prevClick($(this));
			})

			$(".tab-banner-content .nextTabBanner").on("click", function(){
				nextClick($(this));
			})

			function prevClick(arrow){
				var tabToGo = parseInt($(".menuTabBanner .swiper-slide.activeTab").data("tab").split("b")[1]) - 1;
				$(".menuTabBanner .swiper-slide.tabBanner"+tabToGo).trigger("click");
				if (tabToGo === 0){
					disabledArrows(arrow);
					enabledArrows($(".tab-banner-content .nextTabBanner"));
				}
				else {
					enabledArrows(arrow);
					enabledArrows($(".tab-banner-content .nextTabBanner"));
				}
			}

			function nextClick(arrow){
				var tabToGo = parseInt($(".menuTabBanner .swiper-slide.activeTab").data("tab").split("b")[1]) + 1;
				$(".menuTabBanner .swiper-slide.tabBanner"+tabToGo).trigger("click");
				if (tabToGo === $(".menuTabBanner .swiper-slide").length - 1){
					disabledArrows(arrow);
					enabledArrows($(".tab-banner-content .prevTabBanner"));
						}
				else {
					enabledArrows(arrow);
					enabledArrows($(".tab-banner-content .prevTabBanner"));
				}
			}

		}
		// SINO HAY MÁS DE UNA PESTAÑA, TODO SE QUEDA EN DISABLED
		else {
			disabledArrows($(".tab-banner-content .prevTabBanner"));
			disabledArrows($(".tab-banner-content .nextTabBanner"));
		}

		// FIN CONTROL DE FLECHAS INFERIORES


		// CONTROL DE TAB POR PARAMETRO
		var $arrayIds = [];
			$('.swiper-slide.tab-banner-label').each(function(){
			    var id = $(this).attr('id');
			    $arrayIds.push(id);
			});
		var hashAncla = window.location.hash.split("#")[1];
		if ($.inArray(hashAncla, $arrayIds) !== -1 && hashAncla !== "pestania1"){
			$("#"+hashAncla).trigger("click");
		}

		// FIN CONTROL DE TAB POR PARAMETRO

		// IGUALAR ALTURA DE LOS TABS
		$.fn.equalHeights = function() {
			var maxHeight = 0;
			// get the maximum height
			this.each(function(){
				var $this = jQuery(this);
				if ($this.height() > maxHeight) {
					maxHeight = $this.height(); 
				}
			});
			// set the elements height
			this.each(function(){
				var $this = jQuery(this);
				$this.height(maxHeight);
				containerHeightTabs(maxHeight);
			});
		};

		$(window).load(function() {
			$(".tab-banner-label").equalHeights();
		});

		$(window).resize(function() {
			$(".tab-banner-label").equalHeights();
			// arrowSelected();
		});

		// FIN IGUALAR ALTURA DE LOS TABS

		// COLOCAR ARROW TAB ACTUAL

		// function arrowSelected(){
		// 	$(".arrowSelected").css("left", $(".activeTab").offset().left+($(".activeTab").outerWidth()/2-11)+"px");
		// }

		// FIN COLOCAR ARROW TAB ACTUAL

		function containerHeightTabs(height) {
			$("section.tabs-banner-movil .menuTabBanner .container").height(height);
		}
	}

});